import type { RequestProjectResponse } from '@/api/v4/request-project.api';
import { formatDate } from '@/helpers/format-date';
import { modalState } from '@/state/modal.state';
import { colors } from '@/theme/colors';
import { Button } from '@/ui/button/button';
import { Inline, Stack } from '@/ui/line/line';
import { Logo } from '@/ui/logo/logo';
import { ParagraphSmall, SmallText } from '@/ui/typography/widgets';
import { styled } from 'goober';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

export const PendingRequestCard = ({
  request,
}: {
  request: RequestProjectResponse;
}) => {
  const { t } = useTranslation('notification');
  const setModal = useSetAtom(modalState);

  const handleApprove = () => {
    setModal({
      state: 'approveProjectRequest',
      requestId: request.id,
    });
  };

  const handleReject = () => {
    setModal({
      state: 'rejectProjectRequest',
      requestId: request.id,
    });
  };

  return (
    <Container gap="20px">
      <Inline justifyContent="space-between" alignItems="start">
        <Inline alignItems="center">
          <AuthorInitials name={request.name} />
          <Stack gap="0">
            <ParagraphSmall>{request.name}</ParagraphSmall>
            <SmallText color={colors.gray.c11}>{request.email}</SmallText>
          </Stack>
        </Inline>
        <SmallText>{formatDate(request.createdDate)}</SmallText>
      </Inline>

      <SmallText color={colors.basics.black}>{request.description}</SmallText>

      <Inline gap="16px" justifyContent="start">
        <Button size="big" onClick={handleApprove}>
          {t`acceptRequest`}
        </Button>
        <Button size="big" variant="ghost" onClick={handleReject}>
          {t`reject`}
        </Button>
      </Inline>
    </Container>
  );
};

const Container = styled(Stack)`
  border-radius: 10px;
  border: 1px ${colors.gray.c3} solid;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.basics.white};
  max-width: 670px;
  min-height: unset;
`;

const AuthorInitials = styled(Logo)`
  font-weight: 600;
`;
